import type { DisplayMode, DisplayLayout } from '@/types/book';

/** 根据展示模式创建布局策略，统一处理静态页、翻页索引和翻页边界。 */
export function createDisplayLayout(mode: DisplayMode, pageWidth: number): DisplayLayout {
  if (mode === 'single') {
    return {
      bookWidth: pageWidth,
      pageStep: 1,
      initialPageIndex: 0,
      staticPages: (currentPageIndex) => [{ index: currentPageIndex, x: 0 }],
      flipPageIndexes: (currentPageIndex, direction) =>
        direction === 'forward'
          ? { flipping: currentPageIndex, bottom: currentPageIndex + 1 }
          : { flipping: currentPageIndex - 1, bottom: currentPageIndex },
      canFlip: (currentPageIndex, pageCount, direction) =>
        direction === 'forward' ? currentPageIndex + 1 < pageCount : currentPageIndex > 0
    };
  }

  // 双页封面模型：跨页为 [cur, cur + 1]，封面态是 [-1, 0]。
  return {
    bookWidth: pageWidth * 2,
    pageStep: 2,
    initialPageIndex: -1,
    staticPages: (currentPageIndex) => [
      { index: currentPageIndex, x: 0 },
      { index: currentPageIndex + 1, x: pageWidth }
    ],
    flipPageIndexes: (currentPageIndex, direction) =>
      direction === 'forward'
        ? { flipping: currentPageIndex + 2, bottom: currentPageIndex + 3 }
        : { flipping: currentPageIndex - 1, bottom: currentPageIndex - 2 },
    canFlip: (currentPageIndex, pageCount, direction) =>
      direction === 'forward' ? currentPageIndex + 2 < pageCount : currentPageIndex >= 1
  };
}
